import { useCountUp } from '../hooks/useCountUp';
import { STATS, WHY_CHOOSE_US } from '../constants';

function StatCard({ stat }) {
  const [ref, count] = useCountUp(stat.value, 2000);
  return (
    <div ref={ref} className="glass-css flex flex-col justify-between p-6 sm:p-7">
      <span className="tabular display text-5xl sm:text-7xl">
        {count}
        <span className="text-accent">{stat.suffix}</span>
      </span>
      <p className="mt-6 text-muted">{stat.label}</p>
    </div>
  );
}

export default function Stats() {
  return (
    <section id="why" aria-labelledby="why-title" className="theme-dark sky-noon relative overflow-hidden py-24 sm:py-32">
      <div className="frame grid gap-14 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <h2 id="why-title" className="h-section">
            Why businesses choose Farwings
          </h2>
          <dl className="mt-12 divide-y divide-line border-y border-line">
            {WHY_CHOOSE_US.map((item) => (
              <div key={item.title} className="py-6">
                <dt className="text-xl font-semibold stretch-semi">{item.title}</dt>
                <dd className="mt-2 text-muted">{item.description}</dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:col-span-7 lg:self-end">
          {STATS.map((stat) => (
            <StatCard key={stat.label} stat={stat} />
          ))}
        </div>
      </div>
    </section>
  );
}
